import { render, staticRenderFns } from "./GhostContactsTable.vue?vue&type=template&id=70ce3d2e"
import script from "./GhostContactsTable.vue?vue&type=script&lang=js"
export * from "./GhostContactsTable.vue?vue&type=script&lang=js"
import style0 from "./GhostContactsTable.vue?vue&type=style&index=0&id=70ce3d2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports